import { render, staticRenderFns } from "./ClassHead.vue?vue&type=template&id=568cae10&scoped=true&lang=pug"
import script from "./ClassHead.vue?vue&type=script&lang=js"
export * from "./ClassHead.vue?vue&type=script&lang=js"
import style0 from "./ClassHead.vue?vue&type=style&index=0&id=568cae10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568cae10",
  null
  
)

export default component.exports